import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from '/imports/ui/Button';
import { Input } from '/imports/ui/Input';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { strings } from '/imports/strings';
import { ErrorCode } from '/imports/errors';
import { resetUserPassword } from '/imports/api/users';
import { Logo } from '/imports/ui/Logo';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';

// The old `styled(SignedOutPageStyled)` added no extra rules; render the shared
// component directly.
const ResetPasswordPageStyled = SignedOutPageStyled;

export const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>();
  const params = new URLSearchParams(location.search);
  const jwt = params.get('jwt') || undefined;
  const isSetting = params.get('set');
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await resetUserPassword.call({ password, jwt });
      toast.success(strings.PasswordSuccessfullyChanged());
      navigate('/login');
    }
    catch (error: any) {
      if (error?.error === ErrorCode.invalidPassword) {
        toast.error(strings.PasswordRules());
      }
      else if (error) {
        toast.error(strings.AnErrorOccurredPleaseTryAgainOrContactSupport());
      }
    }
  };
  return (
    <ResetPasswordPageStyled className="page">
      <div className="wrapper">
        <div className="inner-wrapper">
          <div><Logo size={2} /></div>
          <div>
            <h2>{isSetting ? strings.SetPassword() : strings.ResetPassword()}</h2>
          </div>
          <p>{strings.PasswordRules()}</p>
          <form onSubmit={onSubmit}>
            <div className="inputs">
              <Input type="password" placeholder={strings.NewPassword()} value={password} inputId="password-input"
                onChange={(password) => setPassword(password)} autoFocus />
            </div>
            <Button id="set-password-btn" type="submit">
              {isSetting ? strings.SetPassword() : strings.ResetPassword()}
            </Button>
          </form>
        </div>
      </div>
      <PublicFooter />
    </ResetPasswordPageStyled>
  );
};